import Vue from 'vue';
import App from './App.vue';
import eventHub from './scripts/eventHub';
import translate from './scripts/translate';
import { getLang } from './scripts/utils';

Vue.config.productionTip = false;
Vue.prototype.$eventHub = eventHub;
Vue.prototype.$translate = (key) => translate(key, getLang());

new Vue({
  render: (h) => h(App),
}).$mount('#app');
